import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {
    changeBottomNavigation,
    changeTitle,
    setRouteListOrigin,
    setStateGoBackUrl,
    showMenuNavBar
} from "../../actions";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import RouteListComponent from "../../components/Route/RouteListComponent/RouteListComponent";
import ErrorRequestHandler from "../../components/ErrorRequestHandler";
import {Box, Button, Container, Typography} from "@mui/material";
import Constants from "../../config/constants";
import {useUser} from "../../hooks/useUser";
import {useAuth} from "../../context/auth-context";
import {allowGuidebookActivation, isGuidebookBuyed, isGuidebookUnlocked} from "../../utils/helpers";
import {useMatomo} from "@datapunt/matomo-tracker-react";
import TopoAddToCart from "../../components/Route/TopoAddToCart";
import {Link, useParams} from "react-router-dom";
import {useGuidebook} from "../../hooks/useGuidebook";
import AlertComponent from "../../components/AlertComponent";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls} from "../../config/urls";

const screenName = Constants.SCREEN_NAME.TOPO;
const TopoScreen = ({queries, onTitleChange, onBottomNavigationChange, onShowMenuNavBar, setGoBackUrl, setRouteListOrigin, t, i18n}) => {
    const auth = useAuth();
    const {slug} = useParams();
    const { status, data: topo, error } = useGuidebook(slug, i18n.language);
    const { data: user } = useUser(auth?.user?.email, i18n.language);
    const [query, setQuery] = useState(null);
    const unlock = isGuidebookUnlocked(user, topo);
    const buyed = isGuidebookBuyed(user, topo);
    const allowActivation = allowGuidebookActivation(user, topo);
    const { trackPageView } = useMatomo();
    const [showAuthAlert, setShowAuthAlert] = useState(false);
    const [canonical, setCanonical] = useState(null);

    // if (topo?.id && topo?.slug !== slug) {
    //     window.location.replace(window.location.href.replace(new RegExp(slug + '$'),  topo.slug));
    // }

    let defaultQuery = {
        q: '',
        order: "region",
        facets: [],
        openRegionId: null,
        screenChoices: [],
        myroute: false,
        choices: [{name: 'regionIds', selected: [],}],
        offset: 0,
        limit: 20,
        language: null,
        version: 2
    };

    useEffect(() => {
        onBottomNavigationChange(true);
        onShowMenuNavBar(false);
        setGoBackUrl(getUrl(PWAUrls.TOPO_LIST, {lng: i18n.language}));
        setRouteListOrigin( window.location.pathname);
    }, []);

    useEffect(() => {
        if (status === "success") {
            onTitleChange(topo.label);
            trackPageView({
                documentTitle: topo.label, // optional
                href: window.location.pathname,
            });

            setCanonical(getUrl(PWAUrls.TOPO, {lng: i18n.language, slug: topo.slug}));
        }
    }, [status]);

    useSEO({
        title: t("seo.title.guidebook", {label: topo?.label}),
        description: t("seo.description.guidebook", {label: topo?.label, description: topo?.description}),
    }, canonical);

    if (status === "success" && (query === null || query.screenChoices.length === 0)) {
        let query = defaultQuery;
        if (queries[screenName + '-' + topo.id] !== undefined) {
            query = queries[screenName + '-' + topo.id];
        }

        setQuery({...query, screenChoices: [{name: 'guidebookIds', selected: [topo.id]}]})
    }

    const validationLink = getUrl(PWAUrls.TOPO_VALIDATION, {lng: i18n.language, slug: topo?.slug});


    if (showAuthAlert) {
        return (
            <AlertComponent
                title={t("AlertComponent.login.addToCart.title")}
                message={t("AlertComponent.login.addToCart.message")}
                severity={'warning'}
                reload={false}
                backgroundIcon={'book'}
                ctaLabel={t("TopoValidationScreen.alert.guestCta")}
                ctaIcon={'sign-in-alt'}
                ctaLinkTo={getUrl(PWAUrls.USER_LOGIN, {lng: i18n.language})}
                backButtonShow={true}
                backButtonCallback={() => {setShowAuthAlert(false)}}
            />
        )
    }

    return (<>
        {status  === 'pending' &&
        <div className={"loadingWrapper"}>
            <div id="loading"/>
        </div>
        }

        {status === 'error' && error && <ErrorRequestHandler error={error} />}
        {status === 'success' &&
        <Container maxWidth="md" style={{padding: 0, paddingTop: "10px", height: '100%'}}>
            {topo.description &&
            <Box p={1}><div className="wysiwyg" dangerouslySetInnerHTML={{__html: topo.description}}/></Box>
            }
            {!unlock && <Box p={1}>
                <TopoAddToCart topo={topo}
                               unlocked={unlock}
                               setShowAuthAlert={setShowAuthAlert}
                />
            </Box>}
            {unlock && !buyed && allowActivation && validationLink &&
            <Box p={1}>
                <Typography variant="subtitle2" gutterBottom>{t("TopoScreen.unlock.endValidationTime")}</Typography>
                    <Box textAlign='center'>
                        <Button
                            component={Link}
                            to={validationLink}
                            variant="contained"
                            color="primary"
                        >
                            {t("TopoScreen.unlock.cta")}
                        </Button>
                    </Box>
            </Box>
            }

            <Box p={1}><Typography variant="body1">
                <b>{t("TopoScreen.description")}</b>
            </Typography></Box>
            {query !== null &&
            <RouteListComponent
                screenName={screenName + "-" + topo.id}
                query={query}
                facetDistribution={[
                    {name: 'types', display: {type: 'multiple', grid: 12}},
                    {name: 'regionIds', display: {type: 'tree'}},
                    {name: 'orientations', display: {type: 'multiple', grid: 6}},
                    {name: 'difficulties', display: {type: 'multiple', grid: 6}},
                ]}
                guidebook={topo}
            />
            }
        </Container>
        }
    </>);
};

const mapStateToProps = (state) => {
    return {queries: state.search.queries}
};

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
        setGoBackUrl: (url) => {
            dispatch(setStateGoBackUrl(url))
        },
        setRouteListOrigin: (url) => {
            dispatch(setRouteListOrigin(url))
        },
    }
};

export default compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(TopoScreen)
